module.exports = __webpack_public_path__ + "img/closeBtn.be5d26cf.svg";